/**
 * localStorage key set by the app while it runs as the installed PWA (standalone).
 * Because an installed PWA and browser tabs on the same origin share
 * localStorage, a later browser-tab visit can read this to know the app is
 * installed — the reliable signal that does not depend on
 * `navigator.getInstalledRelatedApps()` (Chromium-only, and not on every
 * allowlisted engine).
 */
export const PWA_INSTALLED_STORAGE_KEY = 'jiopc-pwa-installed';

/**
 * Env kill-switch (`environment.blockBrowserAccess`) for the "install required"
 * hard block: block only when the flag is strictly `true` and the session is
 * NOT running as the installed app. A false/missing flag, or any installed-app
 * session, never blocks (fail-open). Kept source-agnostic (takes the flag as an
 * argument) so it is trivial to unit-test and easy to re-point if the flag ever
 * moves.
 */
export function shouldBlockBrowserAccess(
  blockBrowserAccess: boolean | undefined | null,
  isInstalled: boolean,
): boolean {
  return blockBrowserAccess === true && !isInstalled;
}
